import React, { useContext } from 'react';
import FileSaver from 'file-saver';
import { GlobalContext } from '../../reducers/global';
import langs from '../../translations/langs';
import dataSetUrls from '../../constants/dataSetUrls';
import getXML from '../../api/getXml';

const DownloadXml = ({ wcd, text, id  }) => {
    const {
        state: {
            options: { language, dataSet },
        },
    } = useContext(GlobalContext);
    const { dataSets } = langs[language];
    const currentDataSetId = dataSets.filter((val) => val.name === dataSet)[0].id;

    const handleDownload = async () => {
        const anchor = document.createElement('a');
        document.body.appendChild(anchor);
        const blob = await getXML(dataSetUrls[currentDataSetId], {
            wcd,
        });
        const fileName = 'GrowthChart.xml';
        FileSaver.saveAs(blob, fileName);
    };

    return (
        <button id={id} type="button" className="btn large secondary" onClick={handleDownload}>
            {text}
        </button>
    );
};

export default DownloadXml;
